import { Theme, alpha } from '@mui/material';
import { getStyleVariables } from 'styles/vars';
import { DocumentTypes } from 'types';
import OptionalContentList from './OptionalContentList';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { getSeparationHidden } from 'store';
import toggleSeparations from 'utils/toggleSeparations';
import OverprintSwitch from './OverprintSwitch';
import styles from './SingleFileOptionalContent.module.scss';

const useStyles = makeStyles()((theme: Theme) => {
  const styleVariables = getStyleVariables(theme);
  return {
    listBorder: {
      border: `1px solid ${alpha(theme.palette.primary.dark, 0.25)}`,
    },
    scrollBar: styleVariables.scrollBar,
  };
});

const SingleFileOptionalContent = () => {
  const separationHidden = useSelector(getSeparationHidden);
  const [separationsEnabled, setSeparationsEnabled] = useState(separationHidden);

  const handleSeparationsToggle = (enabled: boolean, documentType: DocumentTypes) => {
    toggleSeparations(enabled, documentType);
    setSeparationsEnabled(enabled);
  };

  const { classes } = useStyles();
  return (
    <div className={styles.panel} data-testid="single-file-layer-controls">
      <div className={styles.overprint}>
        <OverprintSwitch documentType={DocumentTypes.target} />
      </div>
      <div className={`${styles.list} ${classes.listBorder} ${classes.scrollBar}`}>
        <OptionalContentList
          documentType={DocumentTypes.target}
          separationsEnabled={separationsEnabled}
          handleSeparationsToggle={(enabled) => handleSeparationsToggle(enabled, DocumentTypes.target)}
        />
      </div>
    </div>
  );
};

export default SingleFileOptionalContent;
